import React from 'react'
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any[]
  documentListing?: any
  handlePermDisabled?: any
  mode?: string
}

export const ChangeApportionmentDetailContent = (props: DetailProps) => {
  const { listEl, listStatus, userList, mode } = props

  const getUserName = (userId: string) => {
    if (!userId || !userList) return 'N/A'
    const user = userList.find((u: any) => u.ID === userId)
    return user?.name || 'N/A'
  }

  const getTotalPercentageChange = () => {
    if (!listEl?.Details || listEl.Details.length === 0) return 0
    return listEl.Details.reduce((sum: number, d: any) => {
      const diff = Math.abs((d.new_percentage || 0) - (d.old_percentage || 0))
      return sum + diff
    }, 0)
  }

  const departmentCount = listEl?.Details?.length || 0
  const totalChange = getTotalPercentageChange()

  return (
    <>
      {/* Asset Summary */}
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Asset Card No.
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.Asset?.asset_card_no || 'N/A'}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Change Date
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.change_date ? formatDate(listEl.change_date) : 'N/A'}
        </div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Asset Name
        </div>
        <div className="mdDesc text-noflow">{listEl?.Asset?.name || 'N/A'}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Category
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.Asset?.Category?.name || 'N/A'}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Document No.
        </div>
        <div className="mdDesc text-noflow">{listEl?.DocNo || 'Draft'}</div>
      </div>

      {/* Apportionment Summary */}
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Departments Affected
        </div>
        <div className="mdDesc text-noflow">{departmentCount}</div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Total % Change
        </div>
        <div className="mdDesc text-noflow">{totalChange.toFixed(2)}%</div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Reason
        </div>
        <div className="mdDesc text-noflow">{listEl?.reason || 'N/A'}</div>
      </div>

      {listEl?.description && (
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Description
          </div>
          <div className="mdDesc text-noflow">{listEl.description}</div>
        </div>
      )}

      {listStatus !== 'ACTIVE' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Submitted By
            </div>
            <div className="mdDesc text-noflow">
              {getUserName(listEl?.submittedBy)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Submitted Date
            </div>
            <div className="mdDesc text-noflow">
              {listEl?.submittedTs ? formatDate(listEl.submittedTs) : 'N/A'}
            </div>
          </div>
        </>
      )}

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Approved By
            </div>
            <div className="mdDesc text-noflow">
              {getUserName(listEl?.approvedBy)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Approved Date
            </div>
            <div className="mdDesc text-noflow">
              {listEl?.approvedTs ? formatDate(listEl.approvedTs) : 'N/A'}
            </div>
          </div>
        </>
      )}

      {listStatus === 'REJECTED' && (
        <>
          <div className="content-wrap full">
            <div className="desc" style={{ color: 'grey' }}>
              Rejection Remark
            </div>
            <div className="mdDesc text-noflow" style={{ color: 'red' }}>
              {listEl?.RejectionRemark || 'N/A'}
            </div>
          </div>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Rejection Date
            </div>
            <div className="mdDesc text-noflow">
              {listEl?.RejectionDate ? formatDate(listEl.RejectionDate) : 'N/A'}
            </div>
          </div>
        </>
      )}
    </>
  )
}
